import type { CompanyStaffMember } from '@/features/company/types'
import { primaryEntityActionButtonClass } from '@/components/ui/entityActionButtonClasses'

/** Matches Property Edit header Save. */
export const PROPERTY_CONTACTS_PRIMARY_BUTTON_CLASS = primaryEntityActionButtonClass

export function staffDisplayName(staff: CompanyStaffMember): string {
  return staff.name || `${staff.first_name || ''} ${staff.last_name || ''}`.trim() || '—'
}

/** User ids eligible for email blast (same rows as row checkboxes). */
export function getSelectableUserIdsForEmail(staff: CompanyStaffMember[]): number[] {
  const ids = staff
    .map((s) => s.user_id)
    .filter((id): id is number | string => id != null && !Number.isNaN(Number(id)))
    .map((id) => Number(id))
  return Array.from(new Set(ids))
}

export function resolvePropertyCompanyId(
  property: Record<string, unknown> | null,
): string | number | undefined {
  return (property?.fk_company_id ?? property?.company_id) as string | number | undefined
}
